export function formatDailyPopupDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function buildDailyPopupDismissKey(popupType, userId, date = formatDailyPopupDate()) {
  return `daily-popup-dismiss:${popupType}:${userId ?? "guest"}:${date}`;
}

export function isDailyPopupDismissed(storage, popupType, userId, date = formatDailyPopupDate()) {
  if (!storage) return false;
  return storage.getItem(buildDailyPopupDismissKey(popupType, userId, date)) === "hidden";
}

export function dismissDailyPopupForToday(storage, popupType, userId, date = formatDailyPopupDate()) {
  if (!storage) return;
  storage.setItem(buildDailyPopupDismissKey(popupType, userId, date), "hidden");
}
